import dimbox from 'dimbox';

document.addEventListener('DOMContentLoaded', () => {
    dimbox.setConfig({
        showFullscreenButton: false,
        iframeTemplate: '<div class="dimbox-iframe-container"><iframe src="{{src}}" class="dimbox-iframe"></iframe></div>',
    });
});
